<div class="root">
  <div class="head">
    <button class="arrow-button" mat-icon-button (click)="toggleChildren()">
      <mat-icon class="collapse-arrow" fontSet="fa" fontIcon="fa-caret-right"></mat-icon>
    </button>
    <a class="link" [routerLink]="['/media/' + bac.url]">
      <span class="link-text">{{ bac.translated$ | async }}</span>
    </a>
    <rk-icon-button
      faIcon="fa-plus"
      [bordered]="true"
      (click)="clickMenu($event)"
    ></rk-icon-button>
    <div class="hoverlay"></div>
  </div>

  <div class="children" [@slideInOutBlock] *ngIf="isOpen">
    <ng-container *ngIf="bac.children && bac.children.length > 0">
      <ng-container *ngFor="let sbac of bac.children">
        <rk-library-sbac-item
          [bac]="sbac"
          *ngIf="!sbac.children || sbac.children.length === 0"
        ></rk-library-sbac-item>
        <rk-library-sbac-group
          [bac]="sbac"
          *ngIf="sbac.children && sbac.children.length > 0"
        ></rk-library-sbac-group>
      </ng-container>
    </ng-container>
  </div>
</div>
